// extracted by mini-css-extract-plugin
export var carousel = "KYAZa";
export var logo = "zCA-V";
export var pressReviewContainer = "qoQwu";
export var reviewText = "VIFKJ";
export var reviewTextWrapper = "focL5";